<script>
  import WallsWidgetService from './service.js';
  import { slide } from 'svelte/transition';
  import {M} from '../../external.js'
  export let wrapperClasses = '',
    post;

  const pollConfig = post.attachments.poll || {};

  const SELECTED_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" ><path d="M320-320h320v-320H320v320ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" ></path ></svg>';
  const NOT_SELECTED_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" ><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Z" ></path ></svg>';

  const getOptionVoteCount = (optionId) => {
    if (!post.poll) {
      return 0;
    }

    const option = post.poll[optionId] || { count: 0, reacted: false };
    return option.count;
  };

  const calculatePercentage = (optionId) => {
    if (totalVote < 1) {
      return 0;
    }

    const vote = getOptionVoteCount(optionId);
    const percentage = (vote * 100) / totalVote;
    return percentage.toFixed(1);
  };

  const isMemberReacted = (optionId) => {
    if (!post.poll) {
      return false;
    }

    const option = post.poll[optionId] || { count: 0, reacted: false };
    return option.reacted;
  };

  const getReactedVotes = () => {
    const reactedOptions = [];
    Object.keys(post.poll).forEach((optionId) => {
      if (post.poll[optionId].reacted) {
        reactedOptions.push(optionId);
      }
    });

    return reactedOptions;
  };

  const optionClicked = async (optionId) => {
    if (!(await WallsWidgetService.isMember())) {
      return;
    }

    const reacted = isMemberReacted(optionId);
    if (!post.poll) {
      post.poll = {};
    }

    if (reacted) {
      removeVote(optionId);
    } else {
      if (pollConfig.type === 'single') {
        const reactedVotes = getReactedVotes();
        reactedVotes.forEach((optId) => removeVote(optId));
      }
      giveVote(optionId);
    }

    // re-render trigger
    pollConfig.options = pollConfig.options;
  };

  const removeVote = (optionId) => {
    WallsWidgetService.removePollVote(post.id, optionId);
    post.poll[optionId].reacted = false;
    post.poll[optionId].count -= 1;
    totalVote -= 1;
  };

  const giveVote = (optionId) => {
    WallsWidgetService.givePollVote(post.id, optionId);
    if (!post.poll[optionId]) {
      // initialize
      post.poll[optionId] = {
        reacted: false,
        count: 0
      };
    }
    post.poll[optionId].reacted = true;
    post.poll[optionId].count += 1;
    totalVote += 1;
  };

  let totalVote = 0;
  pollConfig.options.map((option) => (totalVote += getOptionVoteCount(option.id)));
</script>

<div class="{wrapperClasses} circle-post-poll-wrapper">
  {#each pollConfig.options as option (option.id)}
    <div
      class:active={isMemberReacted(option.id)}
      on:click={() => optionClicked(option.id)}
      on:keypress={() => optionClicked(option.id)}
      class="col20 f-left circle-post-poll-option flex align-center space-between">
      <div class="col20 flex align-center circle-post-poll-option-inner">
        <div
          in:slide={{ axis: 'x' }}
          class="circle-post-poll-option-progress"
          style="width: {calculatePercentage(option.id)}%;">
        </div>
        {@html isMemberReacted(option.id) ? SELECTED_SVG : NOT_SELECTED_SVG}
        <span class="poll-option-name">{option.name}</span>
      </div>
      <div class="flex align-center flex-none" style="z-index: 1;">
        <span class="circle-users-count"
        >{calculatePercentage(option.id)}% ({getOptionVoteCount(option.id)} People)</span>
      </div>
    </div>
  {/each}
  {#if false}
    <div class="col20 f-left circle-post-poll-option flex align-center space-between">
      <div class="col20 flex align-center circle-post-poll-option-inner">
        <input type="text" placeholder="Type your poll option" />
      </div>
      <a class="primaryColor-bg2 general-button gray flex-none"> {M.ADD_POLL_OPTION}</a>
    </div>
  {/if}
</div>
